const input_box = {
    namespaced: true,
    state: {
        visible: false,

        resolve: null,
        reject: null,

        title: null,
        fieldname: null,
        buttontext: null,
        requredvalue: false,
        comment: "",
        oneLine: false,
        oldvalue: null
    },
    mutations: {
        SET_VISIBLE(state, payload) {
            state.visible = payload;
        },
        SET_TITLE(state, payload) {
            state.title = payload ?? "Укажите_причину";
        },
        SET_FIELDNAME(state, payload) {
            state.fieldname = payload ?? "Причина";
        },
        SET_BUTTON_TEXT(state, payload) {
            state.buttontext = payload ?? "Отклонить";
        },
        SET_REQUIRED(state, payload){
            state.requredvalue = payload ?? false;
        },
        SET_COMMENT(state, payload){
            state.comment = payload;
        },
        SET_ONELINE(state, payload){
            state.oneLine = payload;
        },
        SET_OLD_VALUE(state, payload){
            state.oldvalue = payload;
            state.comment = payload;
        },
        SET_RESOLVE(state, payload) {
            state.resolve = payload;
        },
        SET_REJECT(state, payload) {
            state.reject = payload;
        },
    },
    actions: {
        async open({ commit }, { title, fieldname, buttontext, oldvalue, requiredval, in_one_line }) {
            commit('SET_TITLE', title);
            commit('SET_FIELDNAME', fieldname);
            commit('SET_BUTTON_TEXT', buttontext);
            commit('SET_REQUIRED', requiredval);
            commit('SET_ONELINE', in_one_line ?? false);
            if (oldvalue)
                commit('SET_OLD_VALUE', oldvalue);
            else
                commit('SET_COMMENT', "");

            commit('SET_VISIBLE', true);

            return new Promise((resolve, reject) => {
                commit('SET_RESOLVE', resolve);
                commit('SET_REJECT', reject);
            });
        },
        async ok({ commit, state }) {
            commit('SET_VISIBLE', false);
            state.resolve(state.comment);
        },
        async cancel({ commit, state }) {
            commit('SET_VISIBLE', false);
            state.reject({ message: "Cancelled" });
        },
    },
    getters: {
        isVisible: (s) => s.visible,
        getTitle: (s) => s.title,
        getFieldname: (s) => s.fieldname,
        getButtonText: (s) => s.buttontext,
        getComment: (s) => s.comment,
        getOneLine: (s) => s.oneLine,
        getShowOk: (s) => {
            if (!s.requredvalue)
                return !s.oldvalue || s.oldvalue != s.comment;
            else 
                return !!s.comment && (!s.oldvalue || s.oldvalue != s.comment)
        }
    }
}

export default input_box;